export const SLOW_QUERY_GUARD_STORAGE_NAME = 'slowQueryGuard';
export const QUERY_BOUNDARY_STORAGE_NAME = 'queryBoundary';
export const RELAY_SSR_HYDRATION_CONTEXT_STORAGE_NAME = 'relaySSRHydrationContext';
